import { render, staticRenderFns } from "./WorkplaceOverview.vue?vue&type=template&id=604225d0&"
import script from "./WorkplaceOverview.vue?vue&type=script&lang=js&"
export * from "./WorkplaceOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports